import { useEffect, useState } from 'react'
import { weddingInfo } from '../weddingInfo'

/**
 * Whole days from today until the wedding.
 *
 * Counted between local midnights rather than from the current instant, so it
 * ticks over when the date does and matches what a guest would count on a
 * calendar. Doing it from `Date.now()` would leave it saying "411 days" all
 * morning and "410" by teatime.
 */
function daysUntil(iso: string): number {
  const parts = iso.split('-').map(Number)
  const [year, month, day] = [parts[0] ?? 0, parts[1] ?? 1, parts[2] ?? 1]

  const target = new Date(year, month - 1, day)
  const today = new Date()
  const midnight = new Date(today.getFullYear(), today.getMonth(), today.getDate())

  return Math.round((target.getTime() - midnight.getTime()) / 86_400_000)
}

function phrase(days: number): string {
  if (days > 1) return `${days} days to go`
  if (days === 1) return 'Tomorrow'
  if (days === 0) return 'Today'
  if (days === -1) return 'Yesterday'
  return 'Thank you for celebrating with us'
}

/** A live count of the days until the wedding, under the date. */
export function Countdown() {
  const [days, setDays] = useState(() => daysUntil(weddingInfo.isoDate))

  useEffect(() => {
    // Checked every minute rather than scheduled for midnight, because a laptop
    // that was asleep at midnight would otherwise wake showing yesterday.
    const id = window.setInterval(() => setDays(daysUntil(weddingInfo.isoDate)), 60_000)
    return () => window.clearInterval(id)
  }, [])

  return (
    <p className="text-ink-soft text-xs tracking-[0.2em] uppercase">
      {phrase(days)}
    </p>
  )
}
